/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestshowmore2Inputs */

const en_requestshowmore2 = /** @type {(inputs: Requestshowmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

const de_requestshowmore2 = /** @type {(inputs: Requestshowmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Requestshowmore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestshowmore2 = /** @type {((inputs?: Requestshowmore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestshowmore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestshowmore2(inputs)
	return de_requestshowmore2(inputs)
});
export { requestshowmore2 as "requestShowMore" }